import React from 'react';
import { DashboardLayout } from './DashboardLayout';
import { Button } from '../ui';
import { SettingsIcon, GlobeIcon, PaletteIcon, UsersIcon, ShieldIcon } from 'lucide-react';
export function SettingsPage() {
  return <DashboardLayout pageTitle="Event Settings" breadcrumb="Leadership Reset Retreat" data-id="element-1803">
      <div className="flex flex-col lg:flex-row gap-8" data-id="element-1804">
        {/* Settings Nav */}
        <div className="w-full lg:w-64 shrink-0" data-id="element-1805">
          <nav className="space-y-1" data-id="element-1806">
            <button className="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium rounded-lg bg-brand-navy/5 text-brand-navy" data-id="element-1807">
              <GlobeIcon className="w-4 h-4" data-id="element-1808" /> General Details
            </button>
            <button className="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium rounded-lg text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-colors" data-id="element-1809">
              <PaletteIcon className="w-4 h-4" data-id="element-1810" /> Branding
            </button>
            <button className="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium rounded-lg text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-colors" data-id="element-1811">
              <UsersIcon className="w-4 h-4" data-id="element-1812" /> Team Access
            </button>
            <button className="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium rounded-lg text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-colors" data-id="element-1813">
              <ShieldIcon className="w-4 h-4" data-id="element-1814" /> Privacy & Security
            </button>
          </nav>
        </div>

        {/* Settings Content */}
        <div className="flex-1 space-y-6" data-id="element-1815">
          <div className="bg-white rounded-2xl border border-slate-200 shadow-soft p-6 md:p-8" data-id="element-1816">
            <h2 className="text-xl font-bold text-brand-navy mb-6" data-id="element-1817">
              General Details
            </h2>

            <div className="space-y-6 max-w-2xl" data-id="element-1818">
              <div data-id="element-1819">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-1820">
                  Event Name
                </label>
                <input type="text" defaultValue="Leadership Reset Retreat" className="w-full px-4 py-2.5 bg-white border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-teal/20 focus:border-brand-teal" data-id="element-1821" />
              </div>

              <div className="grid sm:grid-cols-2 gap-6" data-id="element-1822">
                <div data-id="element-1823">
                  <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-1824">
                    Start Date
                  </label>
                  <input type="date" defaultValue="2026-05-12" className="w-full px-4 py-2.5 bg-white border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-teal/20 focus:border-brand-teal" data-id="element-1825" />
                </div>
                <div data-id="element-1826">
                  <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-1827">
                    End Date
                  </label>
                  <input type="date" defaultValue="2026-05-14" className="w-full px-4 py-2.5 bg-white border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-teal/20 focus:border-brand-teal" data-id="element-1828" />
                </div>
              </div>

              <div data-id="element-1829">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-1830">
                  Location
                </label>
                <input type="text" defaultValue="Punta Cana, Dominican Republic" className="w-full px-4 py-2.5 bg-white border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-teal/20 focus:border-brand-teal" data-id="element-1831" />
              </div>

              <div data-id="element-1832">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-1833">
                  Event Description
                </label>
                <textarea rows={4} defaultValue="Annual leadership offsite focused on resetting norms, building cross-functional trust, and aligning on Q3/Q4 strategic goals." className="w-full px-4 py-2.5 bg-white border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-teal/20 focus:border-brand-teal resize-none" data-id="element-1834" />
              </div>

              <div className="pt-6 border-t border-slate-200 flex justify-end gap-3" data-id="element-1835">
                <Button variant="outline" data-id="element-1836">Cancel</Button>
                <Button variant="primary" data-id="element-1837">Save Changes</Button>
              </div>
            </div>
          </div>

          <div className="bg-red-50 rounded-2xl border border-red-100 p-6 md:p-8" data-id="element-1838">
            <h3 className="text-lg font-bold text-red-900 mb-2" data-id="element-1839">Danger Zone</h3>
            <p className="text-sm text-red-700 mb-4" data-id="element-1840">
              Permanently delete this event and all associated data, including
              attendee records and reports.
            </p>
            <Button variant="outline" className="border-red-200 text-red-700 hover:bg-red-100" data-id="element-1841">
              Delete Event
            </Button>
          </div>
        </div>
      </div>
    </DashboardLayout>;
}